import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { OhioTitleApplicationReadyToPrintVehicleDto, OhioTitleDto, OhioTitleSelectedVehicleFormDto, OhioTitleVehicleDetailDto } from 'dtos/ohioTitles'
import { download, URIQuery } from 'utils'

const baseUrl = (): string => '/api/ohio-titles'
const guidUrl = (vehicleGuid: string): string => `${baseUrl()}/${encodeURIComponent(vehicleGuid)}`

export const getOhioTitles = () => apiClient.get<ApiResponse<OhioTitleDto>>(baseUrl()).then(res => res.data)

export const getSelectedVehicleForm = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<OhioTitleSelectedVehicleFormDto>>(`${guidUrl(vehicleGuid)}/form`).then(res => res.data)

export const saveOhioTitleApplicationPacket = (vehicleGuid: string, data: OhioTitleVehicleDetailDto, readyToPrint: boolean) =>
  apiClient.post<ApiResponse<OhioTitleDto>>(guidUrl(vehicleGuid) + URIQuery({ readyToPrint }), data).then(res => res.data)

export const generateApplicationPacket = (vehicleGuids: string[]) =>
  apiClient.post<string>(`${baseUrl()}/generate-application-packet`, vehicleGuids).then(res => {
    download(res.data, 'ApplicationPacket.pdf', 'application/zip')
  })

export const markVehiclesReadyForBuildABox = (data: OhioTitleApplicationReadyToPrintVehicleDto[]) =>
  apiClient.post<ApiResponse<OhioTitleDto>>(`${baseUrl()}/ready-for-build-a-box`, data).then(res => res.data)
